








import { Vue, Component } from 'vue-property-decorator';
import Banner from '@/components/Banner.vue';
import BottomTabbar from '@/components/BottomTabbar.vue';
import { getBaseinfo } from '@/api/api';
import * as config from './config';
@Component({
  components: {
    Banner,
    BottomTabbar,
  },
})
export default class Home extends Vue {
  option = config.OPTHINES;
  baseInfo: any = {};
  created() {
    getBaseinfo(this.option.voteName).then((res) => (this.baseInfo = res.data));
    this.$addPv(this.baseInfo.activityId);
  }
}
